import {
  Alert,
  Box,
  Tabs,
  Tab,
} from "@mui/material";
import { useEffect, useState } from "react";
import {
  quotationConfirm,
} from "./confirmationUtils";

import ConfirmationDetails from "./ConfirmationDetails";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import {
  getQuotationAction,
  setUpdateQuatationAction,
} from "../../../store/reducers/customerSlice";
import Notification from "../../../components/common/notification/Notification";

const ConfirmationQuote = () => {
  const [formData, setFormData] = useState<any>(quotationConfirm);
  const [activeTab, setActiveTab] = useState(0);

  const { isQuatationResponse, customerConfirmQuoteDetails } = useSelector(
    (state: any) => state.customer,
  );
  const dispatch = useDispatch();

  const toNumber = (value: any) => {
    if (value === null || value === undefined) return 0;
    const numeric = Number(String(value).replace(/,/g, "").trim());
    return Number.isFinite(numeric) ? numeric : 0;
  };

  const getCancellationCharge = (quoteTotal: any, percent: any) => {
    return ((toNumber(quoteTotal) * toNumber(percent)) / 100).toFixed(2);
  };

  const cancellationFees = formData?.financialInfo?.cancellation_fees || [];
  const feeOne = cancellationFees[0];
  const feeTwo = cancellationFees[1];
  const totalQuoteValue = formData?.quoteTotal ?? formData?.quotetotal;

  const getValue = (obj: any, ...keys: string[]) => {
    for (const key of keys) {
      if (obj?.[key] !== undefined && obj?.[key] !== null) return obj[key];
    }
    return undefined;
  };

  // Normalize quote fields used by UI (supports camelCase + lowercase keys)
  const filterQuoteFields = (quote: any) => {
    if (!quote) return {};

    return {
      quoteid: getValue(quote, "quoteid", "quoteId", "id"),
      quotenote: getValue(quote, "quotenote", "quoteNote"),
      notes: getValue(quote, "notes"),
      transportnote: getValue(quote, "transportnote", "transportNote"),
      quotetotal: getValue(quote, "quotetotal", "quoteTotal"),
      quoteTotal: getValue(quote, "quoteTotal", "quotetotal"),
      vatincluded: getValue(quote, "vatincluded", "vatIncluded"),
      accepted_status: getValue(
        quote,
        "accepted_status",
        "acceptedStatus",
      ),
      paymentmethod: getValue(quote, "paymentmethod", "paymentMethod"),
      insuranceamount: getValue(quote, "insuranceamount", "insuranceAmount"),
      insurancepercentage: getValue(
        quote,
        "insurancepercentage",
        "insurancePercentage",
      ),
      insurancetype: getValue(quote, "insurancetype", "insuranceType"),
      isinsuranceaccepted: getValue(
        quote,
        "isinsuranceaccepted",
        "isInsuranceAccepted",
      ),
      quoteexpireson: getValue(quote, "quoteexpireson", "quoteExpiresOn"),
      contentvalue: getValue(quote, "contentvalue", "contentValue"),
      materialpricechargeable: getValue(
        quote,
        "materialpricechargeable",
        "materialPriceChargeable",
      ),
      collectFrom: getValue(quote, "collectFrom", "collectfrom") || [],
      deliveryTo: getValue(quote, "deliveryTo", "deliveryto") || [],
      services: getValue(quote, "services") || [],
      materials: getValue(quote, "materials") || [],
      financialInfo: getValue(quote, "financialInfo", "financialinfo"),
      isSubmitted: getValue(quote, "isSubmitted", "issubmitted", "isSubmitted"),
      thankYouMessage: getValue(
        quote,
        "thankYouMessage",
        "thankyoumessage",
      ),
      name: getValue(quote, "name"),
    };
  };

  const confirmations = (customerConfirmQuoteDetails?.quotes || []).map(
    filterQuoteFields,
  );

  useEffect(() => {
    // Use the confirmation from the active tab
    const currentConfirmation = confirmations[activeTab] || {};
    // If you need to set default values for missing fields, do it here
    setFormData(currentConfirmation);
  }, [confirmations, activeTab]);

  useEffect(() => {
    // dispatch(getQuotationAction());
  }, [dispatch]);

  // Remove unused isDoorToDoorAccept and isFullPackAccept state/effects

  useEffect(() => {
    if (isQuatationResponse) {
      // dispatch(getQuotationAction());
      dispatch(setUpdateQuatationAction(false));
    }
  }, [isQuatationResponse, dispatch]);

  return (
    <>
      <Notification />
      {formData?.thankYouMessage && formData?.isSubmitted && (
        <Alert severity="success">{formData?.thankYouMessage}</Alert>
      )}

      {/* Tabs for multiple confirmations */}
      {confirmations.length > 1 && (
        <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 2 }}>
          <Tabs
            value={activeTab}
            onChange={(e, newValue) => setActiveTab(newValue)}
            variant="scrollable"
            scrollButtons="auto"
            sx={{
              "& .MuiTab-root": {
                textTransform: "none",
                fontWeight: 600,
                fontSize: "16px",
              },
            }}
          >
            {confirmations.map((confirmation: any, index: number) => (
              <Tab key={index} label={`Confirmation ${index + 1}`} />
            ))}
          </Tabs>
        </Box>
      )}
      {formData && formData?.services?.length > 0 ? (
        <Box
          sx={{
            position: "relative",
            // marginTop: "8px",
            padding: "16px 32px",
            border: "2px solid #f4f4f4",
            borderRadius: "10px",
            background: "#FFF",
          }}
        >
          <ConfirmationDetails formData={formData} />

          {formData?.financialInfo &&
            formData?.financialInfo?.is_cancellation_fees_allowed && (
              <Alert sx={{ mt: 2 }} severity="info">
                <b>Warning:</b> You should be aware that setting the date as
                Confirmed and then moving it up to {feeOne?.days || 0} before
                the service date will incur a cost of £
                {getCancellationCharge(totalQuoteValue, feeOne?.percent)}
                {feeTwo
                  ? ` and moving the date up to ${feeTwo?.days || 0} days before the service date will incur a charge of £${getCancellationCharge(totalQuoteValue, feeTwo?.percent)}.`
                  : "."}
              </Alert>
            )}
        </Box>
      ) : (
        <></>
        // <Box
        //   sx={{
        //     textAlign: "center",
        //     padding: "40px 20px",
        //   }}
        // >
        //   <Typography
        //     variant="h6"
        //     sx={{
        //       fontSize: "16px",
        //       color: "#637381",
        //       marginBottom: "16px",
        //       fontWeight: 500,
        //     }}
        //   >
        //     No confirmation available yet
        //   </Typography>
        // </Box>
      )}
    </>
  );
};
export default ConfirmationQuote;
